import { shouldUseNewEngine } from "./shared/newEngineLogic";

// Which /bar page the bar's QR card gets (see components/BarTabLanding.js).
// No React, no Firebase: tests load this file directly
// (tests/unit/v2-web-dine.test.cjs).
//
// A restaurant on the V2 engine, in a build with a gateway, gets the bar tab
// page on the website; every other one gets the "use the app" page.
export async function chooseBarPage(restaurantId, { gatewayUrl, read }) {
	const id = String(restaurantId || "").trim();
	if (!gatewayUrl || !id) return { page: "app" };
	try {
		const restaurant = await read(id);
		if (!restaurant || !shouldUseNewEngine({ restaurant, gatewayUrl })) return { page: "app" };
		return {
			page: "engine",
			gatewayUrl,
			restaurant: { id, name: restaurant.restaurantName || restaurant.name || "Restaurant" },
		};
	} catch {
		return { page: "app" };
	}
}

// Back from a bank page Stripe sent the guest to while saving a card: the
// SetupIntent to confirm, or a failure to show. Null when this is not a return.
export function cardSetupReturn(search) {
	const params = new URLSearchParams(search || "");
	const setupIntentId = params.get("setup_intent");
	const status = params.get("redirect_status");
	if (!setupIntentId || !status) return null;
	return status === "succeeded" || status === "processing" ? { setupIntentId } : { failed: true };
}

// The tab code the bartender reads out: 8 letters and numbers, spaces and
// dashes ignored. "" until it is a whole code.
export function tabCode(text) {
	const clean = String(text || "").toUpperCase().replace(/[\s-]/g, "");
	return /^[A-Z0-9]{8}$/.test(clean) ? clean : "";
}

// The QR on a tab's printed check opens /bar/<restaurant>?tab=<code>: that
// tab's code, or "" (Karl, 2026-11-01).
export function tabCodeFromSearch(search) {
	return tabCode(new URLSearchParams(search || "").get("tab"));
}
